import { auth } from "../firebaseConfig";
import store from "../store";
import { companyActions } from "../store/company-slice";
import { fetchCompany } from "../utils/http/companies";
import { queryClient } from "../utils/http/queryClient";
import { sleep } from "../utils/system";

export async function rootLoader() {
  new Promise(async () => {
    let activeCompanyId;

    // If we have an activeCompany in our state, no need to fetch its data
    if (store.getState().company?.activeCompany) {
      return;
    }

    // A `?customer=` override is present — let the mail-templates loader decide
    // the active company instead of restoring the last one from localStorage.
    if (new URLSearchParams(window.location.search).get("customer")) {
      return;
    }

    // If we have no active company in our localStorage, no need to fetch its data
    if (!(activeCompanyId = localStorage.getItem("ac"))) {
      return null;
    }

    // We're async, so this will not cause a delay
    let token = null;
    for (let i = 0; i < 10; i++) {
      await sleep(100);
      token = await auth?.currentUser?.getIdToken();
      if (token) break;
    }

    if (!token) {
      return null;
    }

    // Fetch the specific company by ID
    const activeCompany = await queryClient.fetchQuery({
      queryKey: ["company", activeCompanyId],
      queryFn: ({ signal }) => fetchCompany({ companyNameOrId: activeCompanyId, signal }),
      staleTime: 2000,
    });

    console.log(activeCompany);

    store.dispatch(companyActions.setActiveCompany(activeCompany));
  }).then(() => {});
}
